<template>
  <main class="ws-page">
    <header class="ws-page-header">
      <h1 class="ws-page-header__title has-text-weight-bold is-size-2" v-text="$t('Центры проведения демонстрационного экзамена (ЦПДЭ)')"></h1>
      <div class="ws-page-header-actions">
        <ws-permission-node :actions="['create']" effect="display" :resources="['services/de/cpde']">
          <router-link class="ws-button button is-text" to="/de-center/new" tag="button">
            <ws-icon
              class="ws-button__icon is-position-left"
              name="plus-circle"
              :title="$t('Добавить новую заявку')"
              color="#1c3b8d"
              width="20"
              height="20"
            />
            <strong class="ws-button__text has-text-primary" v-text="$t('Новый ЦПДЭ')"></strong>
          </router-link>
        </ws-permission-node>
      </div>
    </header>
    <ws-de-center-list />
  </main>
</template>

<script>
export default {
  name: 'DeCenter'
}
</script>
